module.exports = __webpack_public_path__ + "static/media/beer.51e0f757.svg";